import axios from "axios";

const apiBase = process.env.REACT_APP_API_URL || (typeof window !== "undefined" ? window.location.origin : "http://localhost:3000");
const baseURL = `${apiBase.replace(/\/$/, "")}/api`;

if (typeof window !== "undefined" && !process.env.REACT_APP_API_URL) {
    console.warn("[API] REACT_APP_API_URL tanımlı değil, fallback:", apiBase);
}

const api = axios.create({
    baseURL,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(p =>
        error ? p.reject(error) : p.resolve(token)
    );
    failedQueue = [];
};

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    res => res,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            const refreshToken = localStorage.getItem("refreshToken");
            if (!refreshToken) {
                return Promise.reject(error);
            }

            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                }).then(token => {
                    originalRequest.headers.Authorization = `Bearer ${token}`;
                    return api(originalRequest);
                });
            }

            isRefreshing = true;

            try {
                const { data } = await axios.post(
                    `${process.env.REACT_APP_API_URL}/api/auth/refresh`,
                    { refreshToken }
                );

                localStorage.setItem("token", data.accessToken);
                processQueue(null, data.accessToken);

                originalRequest.headers.Authorization =
                    `Bearer ${data.accessToken}`;

                return api(originalRequest);
            } catch (err) {
                processQueue(err);
                return Promise.reject(err);
            } finally {
                isRefreshing = false;
            }
        }

        return Promise.reject(error);
    }
);

export default api;
